import { useNavigate } from "react-router-dom";
import { Flex, Center, Heading, Image, Text, Box } from "@chakra-ui/react";
import Logo from "../components/Logo";
import PrimaryButton from "../components/PrimaryButton";
import loginImage from "../assets/login.png";
import StlLoader from "../components/StlLoader";

function NewPasswordPage() {
	const navigate = useNavigate();

	const handleClick = () => {
		navigate("/login");
	};

	return (
		<Flex>
			<Box display={{ base: "none", lg: "block" }}>
				<StlLoader
					alternative={
						<Image
							src={loginImage}
							alt="Dan Abramov"
							h="100vh"
							w="50vw"
							display={{ base: "none", lg: "block" }}
						/>
					}
				></StlLoader>
			</Box>
			<Center w="100%">
				<Flex
					direction="column"
					alignItems="left"
					justifyContent={"center"}
					h="100vh"
					w="100%"
					px={{ base: "44px", md: "144px" }}
				>
					<Flex direction="column" alignItems="center">
						<Logo />
						<Heading
							fontWeight={600}
							fontSize="32px"
							lineHeight="48px"
							color="gray.900"
							whiteSpace="nowrap"
						>
							Mot de passe confirmé
						</Heading>
						<Text
							fontWeight={400}
							fontSize="20px"
							lineHeight="30px"
							color="gray.600"
							textAlign="center"
						>
							Votre mot de passe a bien été réinitialisé !
						</Text>
					</Flex>
					<PrimaryButton mt="24px" onClick={handleClick}>
						Continuer
					</PrimaryButton>
				</Flex>
			</Center>
		</Flex>
	);
}

export default NewPasswordPage;
